import { LinkBoardingPassBody, MakeBooking } from '@utils/types';
import { axiosInstance } from '.';

export const checkCardAuthenticity = async (
  cardNumber: string,
): Promise<any> => {
  const res = await axiosInstance.post('/v1/self/card', {
    card_number: cardNumber,
  });
  return res.data.data;
};

export const checkEligibilityApi = async (data: any): Promise<any> => {
  const res = await axiosInstance.post('/v1/self/eligibility/check', data);
  return res.data;
};

export const purchaseService = async (
  data: MakeBooking,
): Promise<{ transaction_id?: string } | null> => {
  const res = await axiosInstance.post('/v1/self/booking/create', data);
  const { redirect_url: redirectUrl = '', ...responseData } = res.data.data;
  if (redirectUrl !== '') {
    window.open(redirectUrl, '_self');
    return null;
  }
  return responseData;
};

export const getTransactionDetailsById = async (
  transaction_id: string,
  signal?: AbortSignal,
): Promise<any> => {
  const res = await axiosInstance.post(
    '/v1/self/payment/status',
    { transaction_id },
    { signal },
  );
  return res.data.data ?? {};
};

export const generateQr = async (
  transaction_id: string,
  signal?: AbortSignal,
): Promise<any> => {
  const res = await axiosInstance.get('/v1/self/qr/generate', {
    signal,
    params: {
      transaction_id,
    },
  });
  return res.data;
};

export const linkBoardingPass = async (
  body: LinkBoardingPassBody,
): Promise<true> => {
  await axiosInstance.post('/v1/self/boardingpass/link', body);
  return true;
};
